// HOOKS
import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
// GRAPHQL
import { GET_ROIS } from "../../graphql/queries/rois/rois.queries";
import convertToyyyyMMddThhmm from "../../utils/conversions/dates/yyyyMMddThhmm.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 0,
  sort: "-updated_at",
};
const useGetManyROIs = () => {
  const [rois, setROIs] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [roiInput, setROIInput] = useState({});
  const [getROIQuery, { loading, error, data }] = useLazyQuery(GET_ROIS, {
    fetchPolicy: "no-cache",
  });
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });
  const getROIs = async () => {
    try {
      const res = await getROIQuery({
        variables: { query, roi: roiInput },
      });
      if (res?.data?.rois?.rois)
        setROIs(
          res.data.rois.rois.map((roi) => ({
            ...roi,
            qa_date: convertToyyyyMMddThhmm(new Date(roi?.qa_date)),
          }))
        );
      if (res?.data?.rois?.metaData) setMetaData(res.data.rois.metaData);
    } catch (error) {
      console.error(`Error getting roi: ${error?.message}`);
      alert(`Error getting roi: ${error?.message}`);
    }
  };

  // Get ROIs on query or roiInput change
  useEffect(() => {
    getROIs();
  }, [query, roiInput]);

  return {
    getROIs,
    rois,
    setROIs,
    metaData,
    setMetaData,
    roiInput,
    setROIInput,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyROIs;
